export interface GradeMeta {
  code: string;
  label: string;
  /** Tailwind classes for badge coloring. */
  classes: string;
}

const A = 'bg-green-100 text-green-800 border-green-300';
const B = 'bg-yellow-100 text-yellow-800 border-yellow-300';
const C = 'bg-orange-100 text-orange-800 border-orange-300';
const RED = 'bg-red-100 text-red-800 border-red-300';
const NEUTRAL = 'bg-gray-100 text-gray-800 border-gray-300';

const TABLE: Record<string, GradeMeta> = {
  A: { code: 'A', label: 'A', classes: A },
  B: { code: 'B', label: 'B', classes: B },
  C: { code: 'C', label: 'C', classes: C },
  Y: { code: 'Y', label: 'B or C', classes: B },
  O: { code: 'O', label: 'Approved to Open', classes: A },
  N: { code: 'N', label: 'Not Approved to Open', classes: RED },
  P: { code: 'P', label: 'Pass', classes: A },
  F: { code: 'F', label: 'Fail', classes: RED },
  S: { code: 'S', label: 'Suspended', classes: B },
  R: { code: 'R', label: 'Revoked', classes: RED },
  X: { code: 'X', label: 'Closed by SNHD', classes: RED },
};

export function gradeMeta(code: string | null | undefined): GradeMeta {
  if (!code) return { code: '—', label: '—', classes: NEUTRAL };
  return TABLE[code] ?? { code, label: code, classes: NEUTRAL };
}
